module.exports = require('./lib/xml-mapping.js');
